import React from "react";
import { Text } from "../../styles/Common";
import { CustomInputPassword } from "./styles";
import { theme } from "../../styles/theme";

export const Password = ({
  placeholder,
  suffix,
  helper,
  error,
  disabled,
  onChange,
  onPressEnter,
  ...rest
}) => {
  return (
    <div>
      <CustomInputPassword
        placeholder={placeholder}
        suffix={suffix}
        status={error ? "error" : ""}
        disabled={disabled}
        onChange={onChange}
        onPressEnter={onPressEnter}
        {...rest}
      />
      {helper && (
        <Text size={theme.fonts.size.sm} color={theme.colors.salmon} mt="2px">
          {helper}
        </Text>
      )}
    </div>
  );
};
